export default __webpack_public_path__ + "static/media/bigArrowPrimary.ed893c10.svg";